import React, { useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { Route, Routes, Navigate, BrowserRouter, HashRouter, useLocation } from 'react-router-dom'
import LoginPage from './views/Login/LoginPage';
import Dashboard from './views/MainViews/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';
import { useSelector } from 'react-redux'
import Contacts from './views/MainViews/Contacts/Contacts';
import Contact from './views/MainViews/Contacts/Contact';
import Partners from './views/MainViews/Partners/Partners';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/en-gb';
import 'dayjs/locale/zh-cn';
import Partner from './views/MainViews/Partners/Partner';
import ContactGroups from './views/MainViews/ContactGroups/ContactGroups';
import ContactGroup from './views/MainViews/ContactGroups/ContactGroup';
import Users from './views/MainViews/Users/Users';
import User from './views/MainViews/Users/User';
import ContactReport from './views/MainViews/ContactReport/ContactReport';
import CallReport from './views/MainViews/CallReport/CallReport';
import ConversationReport from './views/MainViews/ConversationReport/ConversationReport';
import Calls from './views/MainViews/Calls/Calls';
import Сonversations from './views/MainViews/Сonversation/Сonversations';
import ConversationTemplates from './views/MainViews/ConversationTemplates/ConversationTemplates';
import ConversationTemplate from './views/MainViews/ConversationTemplates/ConversationTemplate';
import WordGroups from './views/MainViews/WordGroups/WordGroups';
import AnalysisTemplates from './views/MainViews/AnalysisTemplate/AnalysisTemplates';
import AnalysisTemplate from './views/MainViews/AnalysisTemplate/AnalysisTemplate';
import DIDs from './views/MainViews/DIDs/DIDs';
import DID from './views/MainViews/DIDs/DID';
import Branches from './views/MainViews/Branches/Branches';
import Branch from './views/MainViews/Branches/Branch';
import Offices from './views/MainViews/Offices/Offices';
import Office from './views/MainViews/Offices/Office';
import WordGroup from './views/MainViews/WordGroups/WordGroup';
import LoginReports from './views/MainViews/LoginReports/LoginReports';
import PrerecordedAudioSnippet from './views/MainViews/PrerecordedAudioSnippets/PrerecordedAudioSnippet';
import PrerecordedAudioSnippets from './views/MainViews/PrerecordedAudioSnippets/PrerecordedAudioSnippets';
import ConversationDetails from './views/MainViews/ConversationDetails/ConversationDetails';
import ConversationDetail from './views/MainViews/ConversationDetails/ConversationDetail';
import SettingsUpConversationTemplate from './views/MainViews/SettingsUpConversationTemplates/SettingsUpConversationTemplate';
import SettingsUpConversationTemplates from './views/MainViews/SettingsUpConversationTemplates/SettingsUpConversationTemplates';
import SattingsUpCTVisuals from './views/MainViews/SattingsUpCTVisual/SattingsUpCTVisuals';
import { debounce } from 'handsontable/helpers';
import Campaigns from './views/MainViews/Campaigns/Campaigns';
import Campaign from './views/MainViews/Campaigns/Campaign';
import ManualCampaign from './views/MainViews/Campaigns/ManualCampaign';
import UserRequests from './views/MainViews/UserRequests/UserRequests';
import ApiDocs from './views/Docs/ApiDocs';
import ReportsForTemplateOptimization from './views/MainViews/ReportsForTemplateOptimization/ReportsForTemplateOptimization';
import SynthAudioFragments from './views/MainViews/SynthAudioFragments/SynthAudioFragments';
import VirtualAssistant from './views/MainViews/VirtualAssistant/VirtualAssistant';
import FakeLayout from './components/Layout/FakeLayout';
import EditConversationFields from './views/MainViews/EditConversationFields/EditConversationFields';
import AIPrompts from './views/MainViews/AIPrompts/AIPrompts';
import AIPrompt from './views/MainViews/AIPrompts/AIPrompt';
import WebCall from './views/MainViews/WebCall/WebCall';
import WidgetBuilder from './views/MainViews/WidgetBuilder/WidgetBuilder';
import KnowledgeBase from './views/MainViews/KnowledgeBase/KnowledgeBase';
import SynthAudioFragment from './views/MainViews/SynthAudioFragments/SynthAudioFragment';
import UserRequest from './views/MainViews/UserRequests/UserRequest';
import { SnackbarProvider } from './utils/SnackbarContext';
import Prompter from './views/MainViews/Prompter/Prompter';
import ApiKey from './views/ApiKey/ApiKey';
import AIFunction from './views/MainViews/AIFunctions/AIFunction';
import AIParameter from './views/MainViews/AIParameters/AIParameter';
import KnowledgeBases from './views/MainViews/KnowledgeBase/KnowledgeBases';
import AIModelAccesses from './views/MainViews/AIModelAccess/AIModelAccesses';
import AIModelAccess from './views/MainViews/AIModelAccess/AIModelAccess';
import ConversationAnalytics from './views/MainViews/ConversationAnalytics/ConversationAnalytics';
import SystemLog from './views/MainViews/SystemLog/SystemLog';
import Functions from './views/MainViews/Functions/Functions';
import Function from './views/MainViews/Functions/Function';
import ConversationCard from './views/MainViews/ConversationDetails/ConversationCard';
import SynthVoices from './views/MainViews/SynthVoices/SynthVoices';
import SynthVoice from './views/MainViews/SynthVoices/SynthVoice';
import PrerecodedVoices from './views/MainViews/PrerecodedVoices/PrerecodedVoices';
import PrerecodedVoice from './views/MainViews/PrerecodedVoices/PrerecodedVoice';
import Channel from './views/MainViews/Channels/Channel';
import Channels from './views/MainViews/Channels/Channels';
import ChannelPermissions from './views/MainViews/ChannelPermissions/ChannelPermissions';
import ChannelPermission from './views/MainViews/ChannelPermissions/ChannelPermission';
import ApiVendors from './views/MainViews/ApiVendors/ApiVendors';
import ApiVendor from './views/MainViews/ApiVendors/ApiVendor';
import ApiServices from './views/MainViews/ApiServices/ApiServices';
import ApiService from './views/MainViews/ApiServices/ApiService';
import ApiServicesPermissions from './views/MainViews/ApiServicesPermissions/ApiServicesPermissions';
import ApiServicesPermission from './views/MainViews/ApiServicesPermissions/ApiServicesPermission';
import ApiServicesLoadbalancingRules from './views/MainViews/ApiServicesLoadBalancingRules/ApiServicesLoadBalancingRules';
import ApiServicesLoadbalancingRule from './views/MainViews/ApiServicesLoadBalancingRules/ApiServicesLoadBalancingRule';
import Publication from './views/MainViews/Publications/Publication';
function App() {
  //Dark mode 
  const [darkMode, setDarkMode] = React.useState(false);

  // Define light and dark themes
  const lightTheme = createTheme(
    {
      palette: {
        primary: {
          main: '#735ee9',
        },
        secondary: {
          main: '#ff4081',
        },
      },
    }
  );
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#FFF',
      },
      secondary: {
        main: '#ff4081',
      },
    },
  });

  

  const toggleDarkMode = () => {
    setDarkMode((prevDarkMode: any) => !prevDarkMode);
  };

  //We take on the access token and the access level from state store
  const isLoggedIn = useSelector(
    (state: any) => !!state.auth.authData.accessToken
  )
  const accesslevel = useSelector(
    (state: any) => state.auth.authData.accesslevel
  )

  //exclusion of unnecessary Layout renderers
  const memoizedLayout = useMemo(() => <Layout />, []);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dashboard = params.get('dashboard');
  const apidocs = params.get('apidocs');
  const contacts = params.get('contacts');
  const contactgroups = params.get('contactgroups');
  const contactreport = params.get('contactreport');
  const campaigns = params.get('campaigns');
  const dids = params.get('dids');
  const calls = params.get('calls');
  const callreport = params.get('callreport');
  const conversations = params.get('conversations');
  const conversationreport = params.get('conversationreport');
  const conversationdetails = params.get('conversationdetails');
  const prerecordedaudiosnippets = params.get('prerecordedaudiosnippets');
  const settingsupconversationtemplates = params.get('settingsupconversationtemplates');
  const wordgroups = params.get('wordgroups');
  const widgetbuilder = params.get('widgetbuilder');


  return (
    <div className="App">
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
          <SnackbarProvider>


            {
              //If there is no access token in the state store -> switch to /login
              !isLoggedIn && <Navigate to="/login" replace />
            }
            {
              // -> switch to dasboard
              dashboard && <Navigate to="/dashboard" replace />
            }
            {
              // -> switch to apidocs
              apidocs && <Navigate to="/apidocs" replace />
            }

            {
              // -> switch to contacts
              contacts && <Navigate to="/contacts" replace />
            }
            {
              // -> switch to contactgroups
              contactgroups && <Navigate to="/contactgroups" replace />
            }
            {
              // -> switch to contactreport
              contactreport && <Navigate to="/contactreport" replace />
            }
            {
              // -> switch to campaigns
              campaigns && <Navigate to="/campaigns" replace />
            }
            {
              // -> switch to dids
              dids && <Navigate to="/dids" replace />
            }
            {
              // -> switch to calls
              calls && <Navigate to="/calls" replace />
            }
            {
              // -> switch to callreport
              callreport && <Navigate to="/callreport" replace />
            }
            {
              // -> switch to conversations
              conversations && <Navigate to="/conversations" replace />
            }
            {
              // -> switch to conversationreport
              conversationreport && <Navigate to="/conversationreport" replace />
            }
            {
              // -> switch to conversationdetails
              conversationdetails && <Navigate to="/conversationdetails" replace />
            }
            {
              // -> switch to prerecordedaudiosnippets
              prerecordedaudiosnippets && <Navigate to="/prerecordedaudiosnippets" replace />
            }
            {
              // -> switch to settingsupconversationtemplates
              settingsupconversationtemplates && <Navigate to="/settingsupconversationtemplates" replace />
            }
            {
              // -> switch to widgetbuilder
              widgetbuilder && <Navigate to="/widgetbuilder" replace />
            }
            {
              // -> switch to wordgroups
              wordgroups && <Navigate to="/wordgroups" replace />
            }
            <Routes>
              <Route path='/' element={memoizedLayout}>
                {/* <Route path='/' element={<FakeLayout/>}> */}
                <Route index element={Number(accesslevel) === 1 ? <Navigate to="/partners" replace /> : Number(accesslevel) === 2 ? <Navigate to="/users" replace /> : Number(accesslevel) === 4 ? <Navigate to="/virtualassistant" replace /> : <Dashboard />} />
                <Route path='contacts' element={<Contacts />} />
                <Route path='contact' element={<Contact />} />
                <Route path='contactgroups' element={<ContactGroups />} />
                <Route path='contactgroup' element={<ContactGroup />} />
                <Route path='contactreport' element={<ContactReport />} />
                <Route path='calls' element={<Calls />} />
                <Route path='editconversationfields' element={<EditConversationFields />} />
                <Route path='callreport' element={<CallReport />} />
                <Route path='conversations' element={<Сonversations />} />
                <Route path='conversationreport' element={<ConversationReport />} />
                <Route path='conversationtemplates' element={<ConversationTemplates />} />
                <Route path='conversationtemplate' element={<ConversationTemplate />} />
                <Route path='conversationdetails' element={<ConversationDetails />} />
                <Route path='conversationdetail' element={<ConversationDetail />} />
                <Route path='conversationcard' element={<ConversationCard />} />
                <Route path='templateoptimization' element={<ReportsForTemplateOptimization />} />
                <Route path='campaigns' element={<Campaigns />} />
                <Route path='campaign' element={<Campaign />} />
                <Route path='manualcampaign' element={<ManualCampaign />} />
                <Route path='settingsupconversationtemplates' element={<SettingsUpConversationTemplates />} />
                <Route path='settingsupconversationtemplate' element={<SettingsUpConversationTemplate />} />
                <Route path='sattingsctvisuals' element={<SattingsUpCTVisuals />} />
                <Route path='partners' element={Number(accesslevel) === 1 ? <Partners /> : <Navigate to="/" replace />} />
                <Route path='partner' element={Number(accesslevel) === 1 ? <Partner /> : <Navigate to="/" replace />} />
                <Route path='users' element={Number(accesslevel) === 1 || Number(accesslevel) === 2 ? <Users /> : <Navigate to="/" replace />} />
                <Route path='user' element={<User />} />
                <Route path='synthvoices' element={Number(accesslevel) === 1 || Number(accesslevel) === 2 ? <SynthVoices /> : <Navigate to="/" replace />} />
                <Route path='synthvoice' element={Number(accesslevel) === 1 || Number(accesslevel) === 2 ? <SynthVoice /> : <Navigate to="/" replace />} />
                <Route path='prerecvoices' element={Number(accesslevel) === 1 || Number(accesslevel) === 2 ? <PrerecodedVoices /> : <Navigate to="/" replace />} />
                <Route path='prerecvoice' element={Number(accesslevel) === 1 || Number(accesslevel) === 2 ? <PrerecodedVoice /> : <Navigate to="/" replace />} />
                <Route path='channels' element={Number(accesslevel) === 1 ? <Channels /> : <Navigate to="/" replace />} />
                <Route path='channel' element={Number(accesslevel) === 1 ? <Channel /> : <Navigate to="/" replace />} />
                <Route path='channelpermissions' element={Number(accesslevel) === 1 ? <ChannelPermissions /> : <Navigate to="/" replace />} />
                <Route path='channelpermission' element={Number(accesslevel) === 1 ? <ChannelPermission /> : <Navigate to="/" replace />} />
                <Route path='apivendors' element={Number(accesslevel) === 1 ? <ApiVendors /> : <Navigate to="/" replace />} />
                <Route path='apivendor' element={Number(accesslevel) === 1 ? <ApiVendor /> : <Navigate to="/" replace />} />
                <Route path='apiservices' element={Number(accesslevel) === 1 ? <ApiServices /> : <Navigate to="/" replace />} />
                <Route path='apiservice' element={Number(accesslevel) === 1 ? <ApiService /> : <Navigate to="/" replace />} />
                <Route path='apiservicespermissions' element={Number(accesslevel) === 1 ? <ApiServicesPermissions /> : <Navigate to="/" replace />} />
                <Route path='apiservicespermission' element={Number(accesslevel) === 1 ? <ApiServicesPermission /> : <Navigate to="/" replace />} />
                <Route path='apiservicesloadbalancingrules' element={Number(accesslevel) === 1 ? <ApiServicesLoadbalancingRules /> : <Navigate to="/" replace />} />
                <Route path='apiservicesloadbalancingrule' element={Number(accesslevel) === 1 ? <ApiServicesLoadbalancingRule /> : <Navigate to="/" replace />} />
                <Route path='prerecordedaudiosnippets' element={<PrerecordedAudioSnippets />} />
                <Route path='prerecordedaudiosnippet' element={<PrerecordedAudioSnippet />} />
                <Route path='synthaudiofragments' element={<SynthAudioFragments />} />
                <Route path='synthaudiofragment' element={<SynthAudioFragment />} />
                <Route path='wordgroups' element={<WordGroups />} />
                <Route path='wordgroup' element={<WordGroup />} />
                <Route path='analysistemplates' element={<AnalysisTemplates />} />
                <Route path='analysistemplate' element={<AnalysisTemplate />} />
                <Route path='dids' element={<DIDs />} />
                <Route path='did' element={<DID />} />
                <Route path='userrequests' element={<UserRequests />} />
                <Route path='userrequest' element={<UserRequest />} />
                <Route path='branches' element={<Branches />} />
                <Route path='branch' element={<Branch />} />
                <Route path='offices' element={<Offices />} />
                <Route path='office' element={<Office />} />
                <Route path='loginreports' element={<LoginReports />} />
                <Route path='virtualassistant' element={<VirtualAssistant />} />
                <Route path='/webcall' element={<WebCall />} />
                <Route path='/widgetbuilder' element={<WidgetBuilder />} />
                <Route path='/aiprompts' element={<AIPrompts />} />
                <Route path='/aiprompt' element={<AIPrompt />} />
                <Route path='/aifunction' element={<AIFunction />} />
                <Route path='/functions' element={<Functions />} />
                <Route path='/function' element={<Function />} />
                <Route path='/aiparameter' element={<AIParameter />} />
                <Route path='/publication' element={<Publication />} />
                <Route path='/knowledgebases' element={<KnowledgeBases />} />
                <Route path='/knowledgebase' element={<KnowledgeBase />} />
                {/* <Route path='/aimodelaccesses' element={<AIModelAccesses />} />
                <Route path='/aimodelsallowed' element={<AIModelAccess />} /> */}
                <Route path='/conversationanalytics' element={<ConversationAnalytics />} />
                <Route path='/prompter' element={<Prompter />} />
                <Route path='/apikey' element={<ApiKey />} />
                <Route path='/systemlog' element={<SystemLog />} />
                <Route path='/dashboard' element={<Dashboard />} />
              </Route>
              <Route path='/login' element={<LoginPage />} />
              <Route path='/apidocs' element={<ApiDocs />} />
              <Route path='/openapi.yaml' />
              <Route
                path="*"
                element={<Navigate to="/" replace />}
              />
            </Routes>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>

    </div>
  );
}

export default App;